module.exports = __webpack_public_path__ + "img/assess-51.308f318a.png";